<template>
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                <ul>
                    <li class="item-link">
                        <router-link to="/loja" class="fa fa-home"></router-link>
                    </li>
                    <li class="item-link">
                        <span>Minha Conta</span>
                    </li>
                </ul>
            </div>
            <div class="main-content-area">
                <a class="img" href="https://www.aldo.com.br/loja/campanhas/calculo-fio-b"><img class="banner-fio-b" src="/assets/images/CalculoFioB.jpg" alt="Cálculo do Fio B" title="Cálculo do Fio B"></a>
                <BulmaAccordion :dropdown="false" :icon="'custom' ">
                    <BulmaAccordionItem>
                        <h4 slot="title">Boletos</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para acessar clique
                                            <a :href="`${$SiteUrl}/Financeiro/boleto`"> aqui </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">Cadastro de clientes para Venda Direta</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para acessar o
                                            formulário clique
                                            <a :href="`${$SiteUrl}/loja/minha-conta/cadastro-venda-direta`">
                                                aqui
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem v-if="loadContratoVendaDireta" v-bind:style="permissaoGerarContrato == true ? 'background-color: #e2f7e4;' : ''">
                        <h4 slot="title" style="text-decoration-line: underline; color: #001dda;">Assinar Contrato Comercial com Revenda</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div v-if="token_cliente">
                                        <iframe style="height: 600px; width: 100%"
                                                frameborder="0"
                                                v-bind:src="token_cliente"></iframe>
                                        <div class="col-md-12"
                                             style="
                        font-size: 18px;
                        font-weight: bolder;
                        padding-top: 15px;
                        text-align: center;
                        color: #d11;
                      ">
                                            <p>
                                                Ao concluir a assinatura faça o logout e login novamente
                                                para que as crendenciais para o contrato comercial com revenda sejam
                                                validadas.
                                            </p>
                                        </div>
                                    </div>
                                    <div v-if="permissaoGerarContrato"
                                         class="col-xs-12 col-sm-12">
                                        <button class="btn primary-button"
                                                :disabled="loadingContratoVD"
                                                v-on:click="gerarContrato()"
                                                aria-label="Gerar Contrato">
                                            Gerar Contrato
                                        </button>
                                        <div v-if="loadingContratoVD">
                                            <Loader style="margin-top: 20px" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem v-if="loadContratoVendaDiretaAssinado">
                        <h4 slot="title"><strong>Contrato Comercial Assinado</strong></h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div>
                                        <button class="btn primary-button"
                                                v-on:click="DownloadContrato()"
                                                aria-label="Gerar Contrato">
                                            Download Contrato Assinado
                                        </button>
                                        <div class="col-md-12"
                                             style="
                        font-size: 18px;
                        font-weight: bolder;
                        padding-top: 15px;
                        text-align: center;
                        color: #d11;
                      "></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">Comissão venda direta</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para acessar clique
                                            <a :href="`${$SiteUrl}/financeiro/comissao-venda-direta`">
                                                aqui
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">Controle de Usuários/Senha de Comprador</h4>
                        <div slot="content">
                            <UserControl />
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">Cotação Express</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para acessar o cotação
                                            express clique
                                            <!-- <router-link :to="{name: 'ExpressQuotation'}">aqui</router-link>                       -->
                                            <a :href="`${$SiteUrl}/loja/minha-conta/cotacaoexpress`">
                                                aqui
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">Download de Danfe</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para acessar clique
                                            <a :href="`${$SiteUrl}/loja/minha-conta/download-danfe`">
                                                aqui
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">CALCULADORA SOLAR</h4>
                        <div slot="content">
                            <Integracao />
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">E-Mails Marketing</h4>
                        <div slot="content">
                            <EmailMarketing />
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">Enviar documentos</h4>
                        <div slot="content">
                            <SendDocuments />
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">Importação de Produtos</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para acessar clique
                                            <a :href="`${$SiteUrl}/loja/minha-conta/importacao-produto`">
                                                aqui
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">Meus Pedidos</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <a :href="`${$SiteUrl}/loja/minha-conta/meus-pedidos/C`">
                                                <i class="fa fa-arrow-right"></i> Pedido de Venda Normal
                                            </a>
                                        </p>
                                        <p>
                                            <a :href="`${$SiteUrl}/loja/minha-conta/meus-pedidos/V`">
                                                <i class="fa fa-arrow-right"></i> Pedido de Venda Direta
                                            </a>
                                        </p>
                                        <p>
                                            <a :href="`${$SiteUrl}/loja/minha-conta/meus-pedidos/A`">
                                                <i class="fa fa-arrow-right"></i> Para Ativo Imobilizado
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem>
                        <h4 slot="title">Senha/Email</h4>
                        <div slot="content">
                            <UpdatePasswordEmail />
                        </div>
                    </BulmaAccordionItem>
                    <!-- <BulmaAccordionItem>
                        <h4 slot="title">DOCUMENTAÇÃO API</h4>
                        <div slot="content">
                           <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para acessar clique
                                            <a :href="`${$SiteUrl}/loja/minha-conta/documentacao-api`"> aqui </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem> -->
                    <BulmaAccordionItem v-show="transferenciaSaldo == true">
                        <h4 slot="title">Transferência de Saldo</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para solicitar uma transferência de saldo clique
                                            <a :href="`${$SiteUrl}/loja/minha-conta/transferencia-saldo`"> aqui </a>
                                        </p>
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para consultar transferências de saldo clique
                                            <a :href="`${$SiteUrl}/loja/minha-conta/consultar-transferencia-saldo`"> aqui </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem v-show="comprovanteDeposito == true">
                        <h4 slot="title">Comprovante de Depósito</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para enviar um comprovante de depósito clique
                                            <a :href="`${$SiteUrl}/loja/minha-conta/deposito`"> aqui </a>
                                        </p>
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para consultar seus comprovantes de depósitos clique
                                            <a :href="`${$SiteUrl}/loja/minha-conta/consultar-comprovante-deposito`"> aqui </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                    <BulmaAccordionItem v-show="estorno == true">
                        <h4 slot="title">Estorno</h4>
                        <div slot="content">
                            <div class="form-nested-accordion">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para solicitar um Estorno clique
                                            <a :href="`${$SiteUrl}/loja/minha-conta/estorno`"> aqui </a>
                                        </p>
                                        <p>
                                            <i class="fa fa-arrow-right"></i> Para consultar Estornos clique
                                            <a :href="`${$SiteUrl}/loja/minha-conta/consultar-estorno`"> aqui </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BulmaAccordionItem>
                </BulmaAccordion>
            </div>
        </div>
    </main>
</template>

<script>
    import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
    import UpdatePasswordEmail from "./partials/my-account/UpdatePasswordEmail.vue";
    import SendDocuments from "./partials/my-account/SendDocuments.vue";
    import Integracao from "./partials/my-account/Integracao.vue";
    import EmailMarketing from "./partials/my-account/EmailMarketing.vue";
    import UserControl from "./partials/my-account/UserControl.vue";
    import axios from "axios";

    export default {
        name: "MyAccount",
        components: {
            BulmaAccordion,
            BulmaAccordionItem,
            UpdatePasswordEmail,
            SendDocuments,
            Integracao,
            EmailMarketing,
            UserControl,
        },
        props: {
            msg: String,
        },
        async mounted() {

            const logon = localStorage.getItem('usuarioLogado')
            if (logon) {
                this.session = JSON.parse(logon)
                if (this.session.DadosCliente.SituacaoCadastro !== 0) {
                    window.location = '/cadastro/' + this.session.DadosCliente.CliCiccgc
                }
            }

            localStorage.currentStep = 0;
            const self = this;
            $.ajax({
                url: this.$apiUrl + "Session.svc/getsessions",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                error: () => {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning",
                    }).then(
                        () =>
                        (location.href =
                            `${self.$SiteUrl}/login?redirectTo=` + location.href)
                    );
                },
            });

            var xhr = new XMLHttpRequest();
            xhr.onload = () => {
                if (xhr.status == 200) {
                    let loadContratoVendaDiretaParam = JSON.parse(xhr.response);
                    if (loadContratoVendaDiretaParam == "GERARCONTRATO") {
                        self.permissaoGerarContrato = true;
                        self.loadContratoVendaDireta = true;
                    } else if (loadContratoVendaDiretaParam == "NAOPERMITIR" || loadContratoVendaDiretaParam == "FALHA") {
                        self.loadContratoVendaDireta = false;
                    } else if (loadContratoVendaDiretaParam == "CONTRATOGERADO") {
                        self.loadContratoVendaDiretaAssinado = true;
                    } else {
                        self.token_cliente = "https://www.aldo.com.br/OldSite/Asp.Net/assinaturas/Default.htm?token=" + loadContratoVendaDiretaParam;
                        self.loadContratoVendaDireta = true;
                    }
                }
            };
            xhr.open("GET", this.$apiUrl + "Cliente.svc/getclientecontratorevendas");
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.withCredentials = true;
            xhr.send();
            self.$forceUpdate();
            this.transferenciaSaldo = await self.CarregarLinksCC('HABILITAR_SOLICITACAO_TRANSFERENCIA_SITE');
            this.comprovanteDeposito = await self.CarregarLinksCC('HABILITAR_ENVIO_DEPOSITO_SITE');
            this.estorno = await self.CarregarLinksCC('HABILITAR_SOLICITACAO_ESTORNO_SITE');
        },
        methods: {
            async DownloadContrato() {
                return await axios({
                    method: "GET",
                    url: this.$apiUrl + "Cliente.svc/getcontratorevendas",
                    withCredentials: true,
                    responseType: 'blob', // important
                }).then((response) => {
                    let session = JSON.parse(localStorage.getItem('usuarioLogado'));
                    var namefile = "CONTRATO_REVENDA_" + session.DadosCliente.CliCodigo.toString();
                    var namefile = namefile + ".pdf";
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', namefile);
                    document.body.appendChild(link);
                    link.click();



                    // const url = window.URL.createObjectURL(new Blob([response.data]));
                    // const link = document.createElement('a');
                    // link.href = url;
                    // link.setAttribute('download', 'file.pdf'); //or any other extension
                    // document.body.appendChild(link);
                    // link.click();
                    // var blob = new Blob([response.data], {
                    //     type: 'application/pdf'
                    // });
                    // var url = window.URL.createObjectURL(blob)
                    // window.open(url);
                });
            },
            validateEmail(email) {
                const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            validateDate(email) {
                const re = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
                return re.test(email);
            },
            async gerarContratoRevenda(_pparametro, _tpparametro) {
                return await axios({
                    method: "POST",
                    url: this.$apiUrl + "Cliente.svc/gerarDocumentoConRevendas",
                    withCredentials: true,
                    data: { parametro: _pparametro, tpParametro: _tpparametro },
                    contentType: "application/json",
                    dataType: "json",
                }).then((response) => {
                    let result = JSON.parse(response.data);
                    if (result != "E-mail é Obrigatório") {
                        swal({
                            title: result.mensagem,
                            icon: "success",
                        }).then(() => (location.href = window.location.href));;
                    }
                    return result;
                });
            },
            async gerarContrato() {
                try {
                    this.loadingContratoVD = true;
                    let returnresult = await this.gerarContratoRevenda("", "");
                    var self = this;
                    if (returnresult.nome === "") {
                        this.loadingContratoVD = false;
                        swal({
                            title: "Sua empresa não possui sócios no cadastro da Aldo ",
                            icon: "info",
                            text: "Para atualizar o cadastro enviar o contrato social e/ou alterações para cadastro@aldo.com.br"
                        });
                    }
                    else {
                        if (returnresult.mensagem == "E-mail é Obrigatório") {
                            this.loadingContratoVD = false;
                            swal({
                                title: "Preencher E-mail do Sócio: ",
                                icon: "info",
                                text:
                                    returnresult.nome +
                                    " \r\n\nSe o sócio informado não for o que irá realizar a assinatura entre em contato com seu vendedor para alteração !",
                                content: "input",
                                showCloseButton: true,
                                showCancelButton: true,
                                focusConfirm: false,
                            }).then((value) => {
                                if (self.validateEmail(value)) {
                                    this.loadingContratoVD = true;
                                    this.gerarContratoRevenda(value, 'Mail');

                                } else
                                    swal({
                                        title: "E-mail Inválido",
                                        text: value,
                                        icon: "warning",
                                    });
                            });
                        }
                        if (returnresult.mensagem == "Data de Nascimento é Obrigatória") {
                            this.loadingContratoVD = false;
                            swal({
                                title: "Preencher Data de Nascimento do Sócio: ",
                                icon: "info",
                                text:
                                    returnresult.nome +
                                    " \r\n\nSe o sócio informado não for o que irá realizar a assinatura entre em contato com seu vendedor para alteração !",
                                content: {
                                    element: "input",
                                    attributes: {
                                        placeholder: "01/01/1980"
                                    }
                                },
                                showCloseButton: true,
                                showCancelButton: true,
                                focusConfirm: false,
                            }).then((value) => {
                                if (self.validateDate(value)) {
                                    this.loadingContratoVD = true;
                                    this.gerarContratoRevenda(value, 'DataNascimento');

                                } else
                                    swal({
                                        title: "Data de Nascimento Inválida",
                                        text: "Favor preencher no formato DD/MM/AAAA\n\n" + value,
                                        icon: "warning",
                                    });
                            });
                        }
                        if (returnresult.mensagem = '') {
                            swal({
                                title: returnresult.mensagem,
                                icon: "info",
                            }).then(() => (location.href = window.location.href));
                        }
                    }


                } catch (err) {
                } finally {
                    this.loadingContratoVD = false;
                }
            },

            async CarregarLinksCC(parNome){
                return await axios({
                    method: "GET",
                    url: this.$apiUrlAPI + "Parametros/Consultar",
                    headers: {"Content-Type": "application/json"},
                    params: {'nomeParametro': parNome}
                }).then(response => {
                    if(response.status == 200){
                        if(response.data.parValor != "N")
                        {
                            return true;
                        }
                    }
                    return false;
                }).catch(function (error) {
                    console.log(error);
                    return false;
                });
            },
        },

        data() {
            return {
                loadingContratoVD: false,
                loadContratoVendaDireta: false,
                loadContratoVendaDiretaAssinado: false,
                obj: {
                    Valor: 0,
                },
                contratovendadireta: "",
                token_cliente: "",
                permissaoGerarContrato: false,
                transferenciaSaldo: false,
                comprovanteDeposito: false,
                estorno: false,
            };
        },
    };
</script>

